import React from 'react';
import { css } from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation';
import { usePlaceholderImage } from '@/app/components/hotel-detail/hooks/usePlaceholderImage';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';

/**
 * Placeholder shown when no images are available.
 * Might also add a localized string in future.
 */
export function HeroNoImageAvailable() {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { imageBasePath } = localization;

  return (
    <div
      css={`
        position: relative;
      `}
    >
      {}
      <img
        src={`${imageBasePath}${usePlaceholderImage()}`}
        alt="this hotel has no images available"
        css={`
          object-fit: cover;
          height: 400px;
          width: 100%;
          border-radius: 8px;
        `}
      />
      <span
        css={css`
          color: ${(p) => p.theme.commons.colors.primary};
          font-size: ${(p) => p.theme.commons.font.sizes.large};
          position: absolute;
          right: 6rem;
          top: 2.5rem;
        `}
      >
        {t('vacation.select.details.gallery.noimages')}
      </span>
    </div>
  );
}
